import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import Loader from "../../../Core/Loader/Loader";
import SprPageSkeleton from "../components/SprPageSkeleton/SprPageSkeleton";
import SprNotFoundPage from "../pages/SprNotFoundPage/SprNotFoundPage";
import { SPR_PARENT_ROUTE, SPR_V1_REPORT_ROUTE } from "../services/utils/constants";

const SprParentPage = React.lazy(() => import("../pages/SprParentPage/SprParentPage"));
const StudentProfileReport = React.lazy(
  () => import("../../StudentProfileReport/StudentProfileReport"),
);

/**
 * The whole app on the SPR domain (`isSprHost()`): only the two report links parents are sent,
 * the SPR v2 sent report and the older SPR report. Every other address is a 404 — no login page,
 * no Epicenter routes, no redirect to a dashboard. App.jsx renders this inside its Router and
 * FeatureFlagProvider instead of the normal tree.
 */
const SprHostApp = () => (
  <Switch>
    <Route
      path={SPR_PARENT_ROUTE}
      exact
      render={(props) => (
        <Suspense fallback={<SprPageSkeleton />}>
          <SprParentPage {...props} />
        </Suspense>
      )}
    />
    <Route
      path={SPR_V1_REPORT_ROUTE}
      exact
      render={(props) => (
        <Suspense fallback={<Loader />}>
          <StudentProfileReport {...props} />
        </Suspense>
      )}
    />
    <Route component={SprNotFoundPage} />
  </Switch>
);

export default SprHostApp;
